import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupTitle,
} from "../../../../common_components/common_widgets/popup";
import MdaeButton from "../../../../common_components/common_widgets/button";
import { SET_REQUIRED_FIELDS_POPUP_STATUS } from "./reducers/case-data-reducer";

const RequiredFieldsPopup = () => {
  const dispatch = useDispatch();

  const { visible, fields,isAdvanceToNextRound } = useSelector(
    (state) => state["caseDataReducer"].requiredFieldsPopup || {}
  );


  const closeHandler = () => {
    dispatch({
      type: SET_REQUIRED_FIELDS_POPUP_STATUS,
      data: { visible: false, fields: [] },
    });
  };

  const renderMdaeTitle = useCallback(() => (
    <MdaePopupTitle closePopupHandler={closeHandler}>
      Error : Case Required Fields
    </MdaePopupTitle>
  ), [closeHandler]);
  
  if (!visible) return null;

  const isSingle = fields?.length === 1;

  return (
    <MdaePopup
      deferRendering={false}
      height={320}
      width={520}
      visible={visible}
      className="required-fields-popup"
      id="requiredFieldsPopup"
      mdaeTitleRender={renderMdaeTitle}
      mdaeDataUpdaterConfig={[
        {
          actionType: SET_REQUIRED_FIELDS_POPUP_STATUS,
          reducerName: "caseDataReducer",
          widgetOptionBindings: {
            visible: "requiredFieldsPopup.visible",
          },
        },
      ]}
      mdaeContentRender={() => (
        <MdaePopupContent>
          {isSingle ? (
            <div>
              <b>{fields[0]}</b> is required to {isAdvanceToNextRound ? 'advance case to next round':'put this case in a completed status.'}
              <br />
              <br />
              Please complete <b>{fields[0]}</b> before proceeding.
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: "10px" }}>
                {fields.map((field, index) => (
                  <div key={index}>
                    {index + 1}] {field}
                  </div>
                ))}
              </div>

              <div>
                These fields are required to {isAdvanceToNextRound ? 'advance case to next round.':'put this case in a completed status.'}
                <br />
                Please complete them before proceeding.
              </div>
            </div>
          )}
        </MdaePopupContent>
      )}
      mdaeFooterRender={() => (
        <MdaePopupFooter>
          <MdaePopupFooterEndButtons>
            <MdaeButton
              id="requiredFieldsOkBtn"
              role="primary"
              onClick={closeHandler}
            >
              OK
            </MdaeButton>
          </MdaePopupFooterEndButtons>
        </MdaePopupFooter>
      )}
    />
  );
};

export default RequiredFieldsPopup;